import React, { useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Brands from './components/Brands';
import Products from './components/Products';          // 👈 imported
import WhyChooseUs from './components/WhyChooseUs';
import Markets from './components/Markets';
import Stats from './components/Stats';
import Cta from './components/Cta';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { useScrollReveal } from './hooks/useScrollReveal';

function App() {
  useScrollReveal();

  // Back to Top button logic
  useEffect(() => {
    const backTop = document.getElementById('backTop');
    const handleScroll = () => {
      if (window.scrollY > 600) {
        backTop.classList.add('visible');
      } else {
        backTop.classList.remove('visible');
      }
    };
    window.addEventListener('scroll', handleScroll);
    backTop.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div>
      <Navbar />
      <Hero />
      <About />
      <Brands />
      <Products />            {/* 👈 new section */}
      <WhyChooseUs />
      <Markets />
      <Stats />
      <Cta />
      <Contact />
      <Footer />
      <button className="back-top" id="backTop" aria-label="Back to top">↑</button>
    </div>
  );
}

export default App;